(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lv-entry-gate"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-lv-entry]').forEach((entry) => {
  const root = document.documentElement;
  const pageWrapper = entry.closest('.page-wrapper');
  const action = entry.querySelector('[data-lv-entry-action]');
  const focusables = Array.from(entry.querySelectorAll('a[href]'));
  const targetSelector = action ? action.getAttribute('href') : null;
  const target = targetSelector ? document.querySelector(targetSelector) : null;
  const inertNodes = [];

  if (window.Shopify && window.Shopify.designMode) {
    root.classList.remove('lv-entry-locked', 'lv-entry-entering');
    return;
  }

  const syncHeight = () => {
    const topOffset = Math.max(0, Math.ceil(entry.offsetTop));
    entry.style.setProperty('--lv-header-height', `${topOffset}px`);
  };

  const isolateGate = () => {
    let branch = entry;

    while (branch.parentElement && branch.parentElement !== document.body) {
      Array.from(branch.parentElement.children).forEach((sibling) => {
        if (sibling === branch || sibling.hasAttribute('inert')) return;
        sibling.setAttribute('inert', '');
        inertNodes.push(sibling);
      });
      branch = branch.parentElement;
    }
  };

  const restorePage = () => {
    inertNodes.forEach((node) => node.removeAttribute('inert'));
    inertNodes.length = 0;
    document.removeEventListener('keydown', trapFocus, true);
  };

  const trapFocus = (event) => {
    if (event.key !== 'Tab' || !root.classList.contains('lv-entry-locked')) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (!first || !last) return;

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    } else if (!focusables.includes(document.activeElement)) {
      event.preventDefault();
      first.focus();
    }
  };

  syncHeight();
  window.addEventListener('resize', syncHeight, { passive: true });

  root.classList.add('lv-entry-locked');
  if (pageWrapper) pageWrapper.scrollTop = 0;
  window.scrollTo(0, 0);
  isolateGate();

  if (!action || !target) {
    restorePage();
    root.classList.remove('lv-entry-locked');
    return;
  }

  document.addEventListener('keydown', trapFocus, true);

  action.addEventListener('click', (event) => {
    event.preventDefault();
    if (root.classList.contains('lv-entry-entering')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.classList.add('lv-entry-entering');
    action.setAttribute('aria-disabled', 'true');

    window.setTimeout(() => {
      restorePage();
      entry.hidden = true;
      root.classList.remove('lv-entry-locked', 'lv-entry-entering');

      if (pageWrapper) pageWrapper.scrollTop = 0;
      window.scrollTo(0, 0);

      window.requestAnimationFrame(() => {
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
      });
    }, reduceMotion ? 0 : 220);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
